module.exports = __webpack_public_path__ + "img/fensijingying.3134874d.png";